import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router';
import {fromJS} from 'immutable';
import Tabs from 'sg/Tabs/Tabs.react';
import {history} from 'client/history';
import {resource} from '@albert-io/json-api-framework/request/builder';
import MarkdownRendererV2 from 'generic/MarkdownRendererV2/MarkdownRendererV2.react';
import Button from 'sg/Button/Button.react';

import classroomInsightsStore from '../../ClassroomInsights.store';

import StudentsTable from './StudentsTable/StudentsTable.react';
import QuestionsTable from './QuestionsTable/QuestionsTable.react';

import './standard-insights.scss';

const tabs = fromJS([
  {
    label: 'Students',
    query: {
      tab: null
    }
  },
  {
    label: 'Questions',
    query: {
      tab: 'questions'
    }
  }
]);

export default class StandardInsights extends React.Component {
  static propTypes = {
    location: PropTypes.shape({
      query: PropTypes.shape({
        attempt: PropTypes.string,
        tab: PropTypes.string
      })
    }),
    params: PropTypes.shape({
      classId: PropTypes.string,
      standardId: PropTypes.string
    })
  };

  constructor(props) {
    super(props);
    if (!props.location.query.attempt) {
      history.pushState(null, `/classes/${props.params.classId}/insights`);
    }
  }

  getStandardQuery() {
    return resource('label_v1').mandarkEndpoint(['labels_v1', this.props.params.standardId]);
  }

  renderStandardHeader() {
    const standardQuery = this.getStandardQuery();
    if (!standardQuery.isResourcePopulated()) {
      return null;
    }

    const standard = standardQuery.getResource();
    return (
      <div className='standard-insights__header'>
        <h1 className='standard-insights__heading u-display_flex u-justify-content_space-between'>
          {standard.getName()}
          {this.renderStandardButton(standard)}
        </h1>
        <p>
          <MarkdownRendererV2 text={standard.getText()} />
        </p>
        <p>{standard.getCategory()}</p>
      </div>
    );
  }

  renderStandardButton = (standard) => {
    const subject = classroomInsightsStore.getSubject();
    return (
      <Button
        whiteBg
        onClick={(e) => e.stopPropagation()}
        as={Link}
        to={`/${subject.getUrlSlug()}?standards=${standard.getId()}`}
      >
        Find questions
      </Button>
    );
  };

  render() {
    return (
      <div className='standard-insights'>
        {this.renderStandardHeader()}
        <Tabs className='standard-insights__tabs' content={tabs}>
          {this.props.location.query.tab === 'questions' ? <QuestionsTable /> : <StudentsTable />}
        </Tabs>
      </div>
    );
  }
}
